!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.handleStickyElement(this), this.handleDetailsOpenState(this, '[js-site-header="navGroup"]', "nav-open");
    }
    handleStickyElement(e, t = "is-sticky") {
      if (!e) return;
      const s = () => {
        e.getBoundingClientRect().top <= 0 ? e.classList.add(t) : e.classList.remove(t);
      };
      window.addEventListener("scroll", s), s();
    }
    handleDetailsOpenState(e, t, s) {
      const n = this.querySelectorAll(t);
      if (!e || 0 === n.length) return;
      const i = () => {
        const t = Array.from(n).some((e => e.open));
        document.dispatchEvent(new CustomEvent("header-details:toggled")), t ? e.classList.add(s) : e.classList.remove(s);
      };
      n.forEach((e => {
        e.addEventListener("toggle", i);
      })), i();
    }
  }
  customElements.get("site-header") || customElements.define("site-header", e);
}();